import script from "./GetCountdownIndo.vue?vue&type=script&setup=true&lang=js"
export * from "./GetCountdownIndo.vue?vue&type=script&setup=true&lang=js"

import "./GetCountdownIndo.vue?vue&type=style&index=0&id=685c37c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685c37c6"]])

export default __exports__